import type { ForwardedRef } from "react";
import { useCallback, useRef } from "react";

import type { UseMergedRefResult } from "./types";

/** Merges a consumer ref with an internal ref to the same rendered DOM node. */
export const useMergedRef = <T>(forwardedRef: ForwardedRef<T>): UseMergedRefResult<T> => {
  const elementRef = useRef<T | null>(null);

  const setRef = useCallback(
    (node: T | null) => {
      elementRef.current = node;

      if (typeof forwardedRef === "function") {
        forwardedRef(node);
      } else if (forwardedRef) {
        forwardedRef.current = node;
      }
    },
    [forwardedRef]
  );

  return { elementRef, setRef };
};
